// client/src/components/fornecedores/FiltroFornecedores.js - VERSÃO 100% PADRONIZADA
import React, { useState, useEffect } from 'react';
import { Search, X, Loader2 } from 'lucide-react';

const initialFilterState = {
    nome: '',
    documento: '',
    email: '',
    tipoPessoa: '',
    ativo: ''
};

// Padronizei a prop para 'onApplyFilters' para manter consistência com Clientes e Categorias
const FiltroFornecedores = ({ onApplyFilters, onUpdateFilters, activeFilters = {}, loading }) => {
    const [localFilters, setLocalFilters] = useState(initialFilterState);

    // Suporte retroativo para onUpdateFilters se necessário, mas prefira onApplyFilters
    const applyCallback = onApplyFilters || onUpdateFilters;

    useEffect(() => {
        const cleanActive = Object.fromEntries(
            Object.entries(activeFilters).filter(([_, v]) => v != null && v !== '')
        );
        setLocalFilters(prev => ({ ...initialFilterState, ...cleanActive }));
    }, [activeFilters]);

    const onChange = e => {
        setLocalFilters({ ...localFilters, [e.target.name]: e.target.value });
    };

    const onSubmit = e => {
        e.preventDefault();
        
        const filtersToApply = Object.fromEntries(
            Object.entries(localFilters).filter(([_, v]) => v !== '' && v !== null && v !== undefined)
        );
        
        if (applyCallback) {
            applyCallback(filtersToApply);
        }
    };

    const handleClearFilters = () => {
        setLocalFilters(initialFilterState);
        // Tenta limpar usando a prop padrão ou a antiga (onClearFilters) se passada
        if (applyCallback) {
            applyCallback({});
        }
    };

    const hasFilters = Object.values(localFilters).some(v => v !== '');

    return (
        <form onSubmit={onSubmit} className="bg-gray-50 p-4 rounded-lg border border-gray-200 mb-6">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-6 gap-4 items-end">
                
                {/* Campo Nome */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-nome" className="text-xs font-semibold text-gray-600 uppercase">Nome/Razão</label>
                    <input 
                        type="text" 
                        name="nome" 
                        id="filter-nome" 
                        placeholder="Buscar nome..." 
                        value={localFilters.nome} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                </div>

                {/* Campo Documento */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-documento" className="text-xs font-semibold text-gray-600 uppercase">Documento</label>
                    <input 
                        type="text" 
                        name="documento" 
                        id="filter-documento" 
                        placeholder="CPF/CNPJ" 
                        value={localFilters.documento} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                </div>

                {/* Campo Email */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-email" className="text-xs font-semibold text-gray-600 uppercase">Email</label>
                    <input 
                        type="text" 
                        name="email" 
                        id="filter-email" 
                        placeholder="Email..." 
                        value={localFilters.email} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all"
                    />
                </div>

                {/* Campo Tipo Pessoa */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-tipoPessoa" className="text-xs font-semibold text-gray-600 uppercase">Tipo Pessoa</label>
                    <select 
                        name="tipoPessoa" 
                        id="filter-tipoPessoa" 
                        value={localFilters.tipoPessoa} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                    >
                        <option value="">Todos</option>
                        <option value="Física">Pessoa Física</option>
                        <option value="Jurídica">Pessoa Jurídica</option>
                    </select>
                </div>

                {/* Campo Status */}
                <div className="flex flex-col gap-1">
                    <label htmlFor="filter-ativo" className="text-xs font-semibold text-gray-600 uppercase">Status</label>
                    <select 
                        name="ativo" 
                        id="filter-ativo" 
                        value={localFilters.ativo} 
                        onChange={onChange} 
                        className="form-input text-sm py-2 px-3 rounded border border-gray-300 focus:ring-2 focus:ring-blue-500 focus:border-transparent outline-none transition-all bg-white"
                    >
                        <option value="">Todos</option>
                        <option value="true">Ativos</option>
                        <option value="false">Inativos</option>
                    </select>
                </div>

                {/* Botões de Ação — antes reinventava cor do zero em Tailwind
                    (bg-blue-600), usava um emoji ⏳ como spinner e o texto
                    "Filtrar" so aparecia acima de 1280px (hidden xl:inline) */}
                <div className="flex gap-2 h-full">
                    <button
                        type="submit"
                        disabled={loading}
                        className="action-button action-button-primary flex-1 justify-center"
                        title="Aplicar Filtros"
                    >
                        {loading ? <Loader2 size={18} className="icon animate-spin" /> : <Search size={18} className="icon" />}
                        Aplicar Filtros
                    </button>

                    {hasFilters && (
                        <button
                            type="button"
                            onClick={handleClearFilters}
                            disabled={loading}
                            className="action-button action-button-secondary justify-center"
                            title="Limpar Filtros"
                        >
                            <X size={18} className="icon" />
                        </button>
                    )}
                </div>
            </div>
        </form>
    );
};

export default FiltroFornecedores;